// eslint-disable-next-line @typescript-eslint/naming-convention
export default class aum {
  constructor() {
    this.dailyAums = [];
    this.endingAumDate = '';
    this.percentDecrease = '';
    this.percentIncrease = '';
    this.startingAumDate = '';
    this.endDateTotalRiaAum = '';
  }
}
